import { Controller } from 'stimulus';

export default class extends Controller {
  checkForConfirmationInputMatch(event) {
    const deletionKeyword = event.currentTarget.dataset.deletionKeywordParam;
    const inputElement = document.getElementById('confirmation_input');

    if (inputElement.value === deletionKeyword) {
      document.getElementById('delete_submit_button').removeAttribute('disabled');
    } else {
      document.getElementById('delete_submit_button').setAttribute('disabled', 'disabled');
    }
  }

  deleteResource(event) {
    // The deletion modal on the old planning view is rendered inside an existing form which is part of a parent component.
    // The simple form helper can't be used in this place because it doesn't render its own form element because of the nesting,
    // resulting in the final document missing the <form> tag in this modal.

    const confirmationInputData = document.getElementById('confirmation_input').value;
    const csrfToken = document.querySelector('meta[name="csrf-token"]');
    const csrf = csrfToken?.getAttribute('content');
    const deleteResourceUrl = event.currentTarget.dataset.deletionUrlParam;
    const resourceType = event.currentTarget.dataset.deletionResourceTypeParam;

    // As a first step, reset the error banner on the modal in case there was a previously failed attempt.
    this.resetErrorBanner(resourceType);

    fetch(deleteResourceUrl, {
      method: 'DELETE',
      headers: { 'X-CSRF-Token': csrf, 'Content-Type': 'application/json' },
      body: JSON.stringify({
        confirmation_input: confirmationInputData,
        planning_board_view: true,
      }),
    }).then((response) => {
      if (response.ok) {
        return response.json().then((json) => {
          window.location = json.redirect;
        });
      }

      return response.json().then((json) => Promise.reject(json));
    }).catch((error) => {
      this.displayError(resourceType, error.error);
    });
  }

  resetErrorBanner(resourceType) {
    const errorBanner = document.getElementById(`delete-${resourceType}-errors`);
    errorBanner.innerHTML = '';
    errorBanner.className = 'hidden';
  }

  displayError(resourceType, error) {
    const errorBanner = document.getElementById(`delete-${resourceType}-errors`);
    errorBanner.innerHTML = error;
    errorBanner.className = 'alert alert-danger';
    document.getElementById('delete_submit_button').removeAttribute('data-loading');
  }
}
